import "./sortableButton.css";


export const SortableButton = ({ column = '', currentSortable = {}, multiSortable = false, callbackFunction = null }) => {
  let changeSortable = function () {
    let direction = 'ASC';
    if ( typeof(currentSortable[column]) !== 'undefined' && currentSortable[column] === 'ASC' ) {
      direction = 'DESC';
    }
    
    let newSortable = {};
    if ( multiSortable ) {
      Object.assign(
          newSortable,
          currentSortable
        );

    }
    newSortable[column] = direction;

    if ( typeof(callbackFunction) === 'function' )
      callbackFunction( newSortable );
  }

  let order_asc_class = (typeof(currentSortable[column]) !== 'undefined' && currentSortable[column] === 'ASC') ? "active" : "";
  let order_desc_class = (typeof(currentSortable[column]) !== 'undefined' && currentSortable[column] === 'DESC') ? "active" : "";


  return (<span className="os-sortable-button" onClick={changeSortable}>
      <span
        className={"fa fa-caret-up " + order_asc_class}
      ></span>
      <span
        className={"fa fa-caret-down " + order_desc_class}
      >
      </span>
    </span>);
};